import { render, staticRenderFns } from "./RequestCommitModal.vue?vue&type=template&id=a5e52532&scoped=true&"
import script from "./RequestCommitModal.vue?vue&type=script&lang=js&"
export * from "./RequestCommitModal.vue?vue&type=script&lang=js&"
import style0 from "./RequestCommitModal.vue?vue&type=style&index=0&id=a5e52532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e52532",
  null
  
)

export default component.exports